import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GlobeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Globe",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.89 20.03c-5.04 0-9.14-4.1-9.14-9.14s4.1-9.14 9.14-9.14 9.14 4.1 9.14 9.14-4.1 9.14-9.14 9.14m0-16c-3.78 0-6.86 3.08-6.86 6.86s3.08 6.86 6.86 6.86 6.86-3.08 6.86-6.86-3.08-6.86-6.86-6.86"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.89 24.6c-3.51 0-7.02-1.34-9.7-4.01a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0c4.46 4.46 11.71 4.46 16.16 0 4.46-4.46 4.46-11.71 0-16.16a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0c5.35 5.35 5.35 14.05 0 19.4a13.7 13.7 0 0 1-9.7 4.01"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.6 31.46h-5.71c-.63 0-1.14-.51-1.14-1.14v-6.86a1.14 1.14 0 1 1 2.28 0v5.71h4.57a1.14 1.14 0 1 1 0 2.28Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.89 31.46H8.18a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28"
    })]
  }));
};